import * as CryptoJS from 'crypto-js';

export const decryptToken = (data: string): string => {
  const secretKey = process.env.CRYPTO_SAML_ENCRYPTED_KEY as string;
  const marker = process.env.CRYPTO_SAML_ENCRYPTION_MARKER as string;
  const encryptedData = data?.substring(marker?.length);
  const decryptedData = CryptoJS.AES.decrypt(encryptedData, secretKey).toString(CryptoJS.enc.Utf8);
  return decryptedData;
};
